export default function ColoredSpan({color, background, children, ...rest}) {
  return (
    children &&
      <span {...rest} style={{
        'backgroundColor': background,
        'color': color
      }}>
        {children}
      </span>
  )
}